require('./receiptsTable.scss');

const PropTypes = require('prop-types');

// @ vendors
const { connect } = require('react-redux');
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ commons
import { OKButton } from 'commonsComponents/OKButton';
const { LoadingSection } = require('commonsComponents/loadingSection');
const { i18n: { FormattedText, formatText, getLanguage } } = require('core/i18n');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { LastMovementsTable } = require('commonsComponents/lastMovementsTable');
// @ components
const ReceiptsTableRow = require('../receiptsTableRow/receiptsTableRow');
const ReceiptDetail = require('../receiptDetail/receiptDetail');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
import { EmptyState } from 'commonsComponents/emptyState';
// @ constants
const { ACCOUNT_DEBITS_TABLE_LIMIT } = require('constants/index');
const { LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY } = require('constants/commonsComponents');
const { BRING_DIRECT_DEBITS } = require('constants/flagBasedFeatures');
const language = getLanguage();
// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

class ReceiptsTable extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            expandedRowId: '',
            maxDocumentsToSee: ACCOUNT_DEBITS_TABLE_LIMIT
        };
    }

    handleRowClick = (rowId) => {
        this.setState({
            expandedRowId: (rowId === this.state.expandedRowId) ? '' : rowId
        })
    }

    handleDirectDebitClick = () => {
        const { accountId, history } = this.props;
        history.push(`/myprofile/accounts/${accountId}/direct-debit`);
    }

    handleViewMore = () => {
        if (this.props.immReceipts.get('byOrder').size > this.state.maxDocumentsToSee) {
            this.setState({
                maxDocumentsToSee: this.state.maxDocumentsToSee + ACCOUNT_DEBITS_TABLE_LIMIT
            })
        }
    }

    renderNotFound = (textKey, iconEmptyState) => {
        const { accountId, immAccounts, flagBasedFeatures } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const isInactiveAccount = immAccount.get('isInactiveAccount');

        let directDebitButton;
        if (this.props.uploadImgDomiciliacionEnabled && !isInactiveAccount && flagBasedFeatures.get(BRING_DIRECT_DEBITS)) {
            directDebitButton = (
                <OKButton modifier="primary" inverse={true} onClick={this.handleDirectDebitClick}>
                    <FormattedText value="accountDebits-directDebitButton" />
                </OKButton>
            );
        }

        return (
            <div className="account-debits__not-found" >
                <EmptyState
                    button={directDebitButton}
                    primaryText={formatText(textKey)}
                    iconType={iconEmptyState}
                />
            </div>
        );
    }

    renderTable = () => {
        const { expandedRowId } = this.state;
        const { flagBasedFeatures, immReceipts, accountId } = this.props;
        const immReceiptsFilteredIds = immReceipts.get('filteredIds');
        const immReceiptsbyId = immReceipts.get('byId');
        const transactionsCount = Math.min(immReceiptsFilteredIds.size, this.state.maxDocumentsToSee);
        const categoryFormattedText = (//Don't remove the span tag it fix a bug with the tooltip
            <span>
                <FormattedText value="receipts-category" format="firstUppercase" />
            </span>
        );
        return(
            <div>
                <LastMovementsTable
                    groupByDate={false}
                    isExpandable={false}
                    columnsCount={6}
                    expandedRowComponent={ReceiptDetail}
                    expandedRowId={expandedRowId}
                    id={accountId}
                    immFlagBasedFeatures={flagBasedFeatures}
                    immTransactionsById={immReceiptsbyId}
                    immTransactionsByOrder={immReceiptsFilteredIds.take(transactionsCount)}
                    onRowClick={this.handleRowClick}
                    rowComponent={ReceiptsTableRow}
                    currentMonthKey={LAST_MOVEMENTS_TABLE_CURRENT_MONTH_KEY}
                    language={language}
                >
                    <thead>
                        <OKTableRow asHeader={true}>
                            <OKTableCell asHeader={true} className="receipts-table__expand">
                                <span></span>
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="receipts-table__date">
                                <FormattedText value="accountDebits-date" />
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="receipts-table__categroy">
                                <OKTooltip
                                    content="myMoneyTransactions-categoryTooltip"
                                    offset={[0, -15]}
                                    target={categoryFormattedText}
                                    type="descriptive"
                                />
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="receipts-table__name">
                                <FormattedText value="accountDebits-emisor" />
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="receipts-table__status">
                                <FormattedText value="accountDebits-status" />
                            </OKTableCell>
                            <OKTableCell className="receipts-table__amount" asHeader={true}>
                                <FormattedText value="accountDebits-amount" />
                            </OKTableCell>
                            <OKTableCell asHeader={true} className="receipts-table__actions">
                                <span></span>
                            </OKTableCell>
                        </OKTableRow>
                    </thead>
                </LastMovementsTable>
                {
                    immReceiptsFilteredIds && immReceiptsFilteredIds.size > this.state.maxDocumentsToSee &&
                    <OKButton modifier="link-complementary" onClick={this.handleViewMore}>
                        <FormattedText value="receipts-viewMore" />
                    </OKButton>
                }
            </div>
        )
    }

    renderContent = () => {
        const { immReceipts } = this.props;
        let textKey;
        let iconEmptyState;
        if (immReceipts && immReceipts.getIn(['byId']).size > 0) {
            const immReceiptsFilteredIds = immReceipts.get('filteredIds');
            if (immReceiptsFilteredIds && immReceiptsFilteredIds.size === 0) {
                return (
                    <div className="receipts-table__not-found" >
                        <EmptyState
                            primaryText={formatText('receipts-notFoundForAppliedFilter')}
                            iconType={iconEmptyState}
                        />
                    </div>
                );
            }
            else {
                return this.renderTable();
            }
        } else if (immReceipts && (immReceipts.getIn(['byId']).size == 0 || immReceipts.get('error'))) {
            if (immReceipts.get('error')) {
                textKey = 'receipts-error';
                iconEmptyState = 'nointernet-banking';
            } else {
                textKey = 'receipts-notFound';
                iconEmptyState = 'noitems-banking';
            }
            return this.renderNotFound(textKey, iconEmptyState);
        } else {
            return <LoadingSection />;
        }
    }

    render() {
        return this.renderContent()
    }
}

ReceiptsTable.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immReceipts: PropTypes.object,
    accountId: PropTypes.string,
    flagBasedFeatures: PropTypes.object,
    uploadImgDomiciliacionEnabled: PropTypes.bool
};

export default connect(
    (state, ownProps) => ({
        immAccounts: state.accounts,
        immReceipts: state.receipts.get(ownProps.accountId),
        flagBasedFeatures: state.flagBasedFeatures,
        uploadImgDomiciliacionEnabled: state.flagBasedFeatures.get('upload-img-domiciliacion-enabled')
    })
)(withFeatureToggling(withRouter(ReceiptsTable)));
